<template>
  <div>
    <div
      v-if="item.status === 'running'"
      style="position:relative;"
    >
      <v-progress-linear
        color="info"
        :height="height || '20'"
        :value="item.progress"
      />
      <span class="progress_text">Executing... ({{item.progress}}%)</span>
    </div>
    <div
      v-if="item.status === 'new'"
      style="position:relative;"
    >
      <v-progress-linear
        color="secondary"
        :height="height || '20'"
        value="100"
      />
      <span class="progress_text">Preparing...</span>
    </div>
    <div
      v-if="item.status === 'failed'"
      style="position:relative;"
    >
      <v-tooltip
        left
        color="error"
        max-width="300"
      >
        <div
          slot="activator"
        >
          <v-progress-linear
            color="red"
            :height="height || '20'"
            :value="item.progress"
          />
          <span
            class="progress_text"
          >
            Failed ({{item.progress}})
          </span>
        </div>
        <span>{{item.error}}</span>
      </v-tooltip>
    </div>
    <div
      v-if="item.status === 'finished'"
      style="position:relative;"
      @click="$emit('download')"
    >
      <div
        v-if="hasErrors"
      >
        <v-tooltip
          left
          color="error"
          max-width="300"
        >
          <div
            slot="activator"
          >
            <v-progress-linear
              color="orange"
              :height="height || '20'"
              value="100"
            />
            <span class="progress_text">
              Finished with Errors
            </span>
          </div>
          <span>Click to view errors</span>
        </v-tooltip>
      </div>
      <div
        v-else
      >
        <v-progress-linear
          color="green"
          :height="height || '20'"
          value="100"
        />
        <span class="progress_text">
          Finished (100%)
        </span>
      </div>
    </div>
  </div>
</template>


<script>
import api from '@/api'
import moment from 'moment'

export default {
  name: 'BulkOpsProgressBar',
  props: [ 'item', 'height' ],
  computed: {
    hasErrors () {
      try {
        if (this.item.issues && JSON.parse(this.item.issues).length > 0)
          return true
      } catch (e) {
        return true
      }
      return false
    }
  }
}
</script>
